export default __webpack_public_path__ + "static/media/Maintanance_icon.57211f4d.gif";